import comissoesTotal from './components/TotalComission/TotalComission.vue'
import formSearchComission from './components/FormSearchComission/FormSearchComission.vue'
import tableComission from './components/TableComission/TableComission.vue'
import Commissiondetails from './components/commissiondetails/commissiondetails.vue'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'

export default {
  name: 'CommissionCheck',
  mixins: [ PermissionMixin ],
  components: {
    comissoesTotal,
    tableComission,
    formSearchComission,
    Commissiondetails
  },
  data () {
    return {
      flDetails: false,
      tablereload: 0,
      keyTotal: 0,
      selectedComissao: {},
      roles: Roles
    }
  },
  methods: {
    edit (obj) {
      this.selectedComissao = obj
      this.flDetails = true
    },
    deleteCommission (id) {
      CommissionRepository.DeleteComissao(id)
        .then(Response => {
          this.consultacomissao = Response.data.data
          this.tablereload++
          this.keyTotal++
          this.$refs.tableGridComission.Delete(Response)
        })
        .catch(() => {})
    },
    GetFilter (filter, isFilter) {
      this.$refs.tableCommissionCheck.searchWithFilter(filter, isFilter)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/commissioncheck.js